import React, { Component } from 'react';
import SearchBar from '../search/SearchBar'; // Import the SearchBar component from the correct path
import BusinessCard from '../business/BusinessCard'; // Import the BusinessCard component from the correct path
import Navbar from '../navbar/Navbar'
import './App.css';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            results: [], // Initialize results here
        };
    }

    // Define a function to update the results state when data is fetched in SearchBar component
    updateResults = (newResults) => {
        this.setState({ results: newResults });
    };

    render() {
        return (
            <div className="App">
                <Navbar />
                <SearchBar updateResults={this.updateResults} /> {/* Pass the updateResults function as a prop */}
                <BusinessCard results={this.state.results} /> {/* Pass the results state to BusinessCard */}
            </div>
        );
    }
}


export default App;
